module.exports = __webpack_public_path__ + "static/media/banner-tablet.975e5013.png";